import React from 'react';
import styled from 'styled-components';

import { MessageProfileNumber, VoiceAppNumber } from '@requests/telnyx';
import { parsePhoneNumber } from 'libphonenumber-js';
import { Skeleton } from '@mui/material';

const Container = styled.div`
  display: flex;
  align-items: center;

  gap: 8px;

  img {
    border-radius: 3px;
  }

  p {
    color: ${({ theme }) => theme.text.standard};
    font-size: 14px;
  }
`;

export const TelnyxNumberGrid = styled.div`
  padding-top: 0.5rem;
  display: grid;
  grid-template-columns: 170px 170px;
  grid-template-rows: repeat(1fr);
  gap: 12px;
`;

interface Props {
  number: VoiceAppNumber | MessageProfileNumber;
}

export const TelnyxNumberList: React.FC<Props> = ({ number }) => {
  const parsedNumber = parsePhoneNumber(number.phone_number);

  return (
    <Container>
      <img
        loading='lazy'
        width='20px'
        height='12px'
        srcSet={`https://flagcdn.com/w40/${parsedNumber?.country?.toLowerCase()}.png 2x`}
        src={`https://flagcdn.com/w20/${parsedNumber?.country?.toLowerCase()}.png`}
        alt=''
      />
      <p>{parsedNumber.formatInternational()}</p>
    </Container>
  );
};

export const NumberSkeletonArray = () => {
  const width = 158;
  const height = 24;

  return (
    <TelnyxNumberGrid>
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
      <Skeleton animation='wave' variant='rounded' width={width} height={height} />
    </TelnyxNumberGrid>
  );
};
